package com.essntl.features.task.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.BasicAlertDialog
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.DialogProperties
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun TaskColumnDialog(
    getAllTask: State<List<TaskModel>>,
    onEditTask: (task: TaskModel) -> Unit,
    onEditTaskStatus: (task: TaskModel, status: TaskModel.Status) -> Unit,
    onDeleteTask: (task: TaskModel) -> Unit,
    onDismissRequest: () -> Unit,
) {
    BasicAlertDialog(
        onDismissRequest = onDismissRequest,
        modifier = Modifier.fillMaxSize(0.7f),
        properties = DialogProperties(
            usePlatformDefaultWidth = false,
        ),
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(25.dp)),
        ) {
            Column(
                horizontalAlignment = Alignment.Start,
                verticalArrangement = Arrangement.Center,
                modifier = Modifier
                    .fillMaxWidth()
                    .background(color = MaterialTheme.esColorScheme.bgPrimary)
                    .padding(bottom = 1.spacing),
            ) {
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(color = Color.White)
                        .padding(
                            vertical = 3.spacing,
                            horizontal = 2.5.spacing,
                        ),
                ) {
                    Text(
                        text = "Tasks",
                        style = MaterialTheme.esTypography.h3Bold24,
                        color = MaterialTheme.esColorScheme.textPrimary,
                        modifier = Modifier.align(Alignment.CenterStart),
                    )

                    EsSmallOutlineIconButton(
                        onClick = onDismissRequest,
                        iconRes = EsIcons.Close,
                        modifier = Modifier.align(Alignment.CenterEnd),
                    )
                }

                if (getAllTask.isLoading)
                    Box(
                        modifier = Modifier.fillMaxSize(),
                    ) {
                        EsSpinner(
                            modifier = Modifier.align(Alignment.Center),
                        )
                    }
                else if (getAllTask.isFailure)
                    Box(
                        modifier = Modifier.fillMaxSize(),
                    ) {
                        Text(
                            text = "Error loading tasks",
                            style = MaterialTheme.esTypography.h3Bold24,
                            color = MaterialTheme.esColorScheme.textPrimary,
                            modifier = Modifier.align(Alignment.Center),
                        )
                    }
                else if (getAllTask.data.isNullOrEmpty())
                    Box(
                        modifier = Modifier.fillMaxSize(),
                    ) {
                        Text(
                            text = "No tasks found",
                            style = MaterialTheme.esTypography.h3Bold24,
                            color = MaterialTheme.esColorScheme.textPrimary,
                            modifier = Modifier.align(Alignment.Center),
                        )
                    }
                else
                    LazyColumn(
                        modifier = Modifier.fillMaxSize(),
                    ) {
                        items(getAllTask.data.orEmpty()) { task ->
                            TaskBox(
                                task = task,
                                onDeleteTask = { onDeleteTask(task) },
                                onEditTask = { onEditTask(task) },
                                onEditTaskStatus = { status -> onEditTaskStatus(task, status) },
                                modifier = Modifier.fillMaxWidth(),
                            )

                            Spacer(modifier = Modifier.height(1.spacing))
                        }
                    }
            }
        }
    }
}